<div
  class="fixed top-0 right-0 bottom-0 left-0 bg-black bg-opacity-30 flex flex-row items-center justify-center"
  style="z-index: 99999"
  (click)="onCancel()"
>
  <img
    (click)="$event.stopPropagation(); onReceive()"
    class="cursor-pointer"
    src="https://oss.image.xiaogetech.com/RBS1681889785301.png"
    width="400"
    alt=""
  />
</div>
